import {isPlatformBrowser} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';

let aosInitialized = false;
let aosModulePromise: Promise<typeof import('aos')> | null = null;

@Injectable({
    providedIn: 'root',
})
export class AosService {
    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
    ) {
    }

    async refresh(): Promise<void> {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        if (!aosModulePromise) {
            aosModulePromise = import('aos');
        }

        const {default: AOS} = await aosModulePromise;

        if (!aosInitialized) {
            AOS.init({
                once: true,
                duration: 650,
                easing: 'ease-out-cubic',
                offset: 48,
                disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
            });
            aosInitialized = true;
        }

        window.requestAnimationFrame(() => {
            AOS.refreshHard();
        });
    }
}
